import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2025 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useEffect, useState } from "react";
import { StatusMessage } from "../../messaging";
import { TsDataSource } from "../../services";
import { Placeholder } from "../..";
function ActionStatus(props) {
    const flowRunId = props.rowData.attributes.params.flow_run_id;
    const flowRunName = props.rowData.attributes.params.flow_run_name;
    const RELOAD_INTERVAL = 10;
    const [status, setStatus] = useState('');
    const [initialLoad, setInitialLoad] = useState(true);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [secondsSinceLastUpdate, setSecondsSinceLastUpdate] = useState(0);
    const convertFlowToMessageStatus = (s) => {
        switch (s) {
            case "Scheduled":
                return "warning";
            case "Pending":
                return "warning";
            case "Completed":
                return "success";
            case "Failed":
                return "error";
            default:
                return "info";
        }
    };
    const getActionStatus = async () => {
        setLoading(true);
        const ds = new TsDataSource();
        return await ds.getOne({
            objectType: "prefect/flow_run",
            id: flowRunId,
        });
    };
    useEffect(() => {
        const intervalId = setInterval(() => {
            setSecondsSinceLastUpdate((prevSeconds) => {
                if (prevSeconds === 0) {
                    getActionStatus()
                        .then((dataObject) => {
                        if (!dataObject)
                            setError(`Failed to fetch status: ${flowRunId}`);
                        const state = dataObject?.state;
                        setStatus(state);
                        setLoading(false);
                        setInitialLoad(false);
                        if (state === "Completed" || state === "Failed") {
                            clearInterval(intervalId);
                        }
                    })
                        .catch((e) => {
                        setError(`Failed to fetch status: ${e.message}`);
                        setLoading(false);
                        setInitialLoad(false);
                    });
                    return RELOAD_INTERVAL;
                }
                return prevSeconds - 1;
            });
        }, 1000);
        return () => clearInterval(intervalId); // cleanup interval on component unmount
    }, []);
    if (error) {
        return (_jsx(StatusMessage, { message: error, status: "error" }));
    }
    if (initialLoad) {
        return _jsx(Placeholder, { loader: true, height: 60 });
    }
    return (_jsxs("div", { children: [_jsxs("div", { children: [_jsx("span", { style: { fontWeight: 'bolder' }, children: "Flow Run Name: " }), _jsx("span", { children: flowRunName })] }), _jsxs("div", { children: [_jsx("span", { style: { fontWeight: 'bolder' }, children: "Flow Run ID: " }), _jsx("span", { children: flowRunId })] }), _jsx("div", { children: loading ?
                    _jsx(Placeholder, { height: 28 })
                    :
                        _jsxs("div", { children: [_jsx(StatusMessage, { message: status, status: convertFlowToMessageStatus(status) }), (status !== "Completed" && status !== 'Failed') && (_jsxs(_Fragment, { children: ["Refreshing in ", secondsSinceLastUpdate, "..."] }))] }) })] }));
}
export default ActionStatus;
